/* tslint:disable */
/* eslint-disable */
export enum WorkJournalEntryStatusEnum {
  Draft = 'draft',
  Posted = 'posted',
  Reversed = 'reversed'
}
